import { RestCollectionView } from '@mescius/wijmo.rest'
import * as wjcXlsx from '@mescius/wijmo.xlsx'
import { getWithDot } from '../utility'
import moment from 'moment'

export default class MyRestCollectionView extends RestCollectionView {
  constructor (url, params, getItemFromData, query = {}, editUrl = '#', getEditFields = null) {
    super()
    this.url = url
    this.params = params
    this.getItemFromData = getItemFromData
    this.query = query
    this.editUrl = editUrl
    this.getEditFields = getEditFields
    this.currentPage = null

    this.pageOnServer = true
    this.sortOnServer = false
    this.filterOnServer = false

    this.setErrorMessage = (message) => null
  }

  async getItems () {
    if (this.pageIndex === this.currentPage) {
      // 読み込み中のページがあるため、新たにリクエストせず現在のアイテムをそのまま返す
      return new Promise((resolve) => resolve(this.items))
    }
    return new Promise((resolve) => {
      this.params.set('page', this.pageIndex + 1)
      Object.keys(this.query).forEach((key) => {
        this.params.set(key, this.query[key])
      })

      this.currentPage = this.pageIndex
      fetch(`${this.url}?${this.params.toString()}`, { method: 'GET' })
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else if (response.status === 429) {
            this.setErrorMessage('大量のアクセスを検知しました。時間を置いて画面を再読み込みしてください。')
            return null
          } else {
            this.setErrorMessage('データの取得に失敗しました。画面を更新して再度お試しください。')
            return null
          }
        })
        .then((data) => {
          if (data) {
            if (this.pageSize !== data.per_page) {
              this.pageSize = data.per_page
            }
            if (this._totalItemCount !== data.total) {
              this._totalItemCount = data.total
            }
            resolve(data.data.map((row) => this.getItemFromData(row)))
          } else {
            resolve([])
          }
        })
        .finally(() => {
        })
        .catch((error) => console.error(error))
    })
  }

  async patchItem (item) {
    const elCsrf = document.querySelector('meta[name="csrf-token"]')
    const editFields = this.getEditFields ? this.getEditFields(item) : item
    const form = new FormData()
    form.append('_token', elCsrf.content)
    for (const field in editFields) {
      form.append(field, editFields[field])
    }
    return new Promise((resolve) => {
      fetch(`${this.editUrl}`, {
        method: 'POST',
        body: form
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data.error_message) {
            elCsrf.content = data._token
            item.updated_at = moment(data.fields.updated_at).format('YYYY-MM-DD HH:mm:ss')
            resolve(item)
          } else {
            this.setErrorMessage(data.error_message)
            resolve(item)
          }
        })
        .finally(() => {
        })
        .catch((error) => {
          this.setErrorMessage('データの更新中にエラーが発生しました。')
          console.error(error)
        })
    })
  }

  async exportAllItems (tableFormat, onPageLoaded) {
    const book = new wjcXlsx.Workbook()
    const sheet = new wjcXlsx.WorkSheet()
    book.sheets.push(sheet)
    sheet.rows[0] = new wjcXlsx.WorkbookRow()
    tableFormat.forEach((col, i) => {
      sheet.rows[0].cells[i] = new wjcXlsx.WorkbookCell()
      sheet.rows[0].cells[i].value = col.text
    })
    let j = 1
    for (let page = 0; page < this.pageCount; page++) {
      await new Promise((resolve) => {
        this.params.set('page', page + 1)
        Object.keys(this.query).forEach((key) => {
          this.params.set(key, this.query[key])
        })
        fetch(`${this.url}?${this.params.toString()}`, { method: 'GET', signal: this.abortSignal })
          .then((response) => response.json())
          .then((data) => {
            data.data.forEach((row) => {
              const item = this.getItemFromData(row)
              sheet.rows[j] = new wjcXlsx.WorkbookRow()
              tableFormat.forEach((col, i) => {
                sheet.rows[j].cells[i] = new wjcXlsx.WorkbookCell()
                sheet.rows[j].cells[i].value = getWithDot(item, col.field)
                if (col.field === 'rate_decimal') {
                  sheet.rows[j].cells[i].style = new wjcXlsx.WorkbookStyle()
                  sheet.rows[j].cells[i].style.format = wjcXlsx.Workbook.toXlsxNumberFormat('P2')
                }
              })
              j += 1
            })
          })
          .finally(() => {
            resolve(page)
          })
          .catch((error) => console.error(error))
      })
      await new Promise((resolve) => setTimeout(resolve, 1000))
      onPageLoaded(page + 1)
    }
    const exportPath = moment().format('YYYY-MM-DD-HHmmss')
    book.saveAsync(exportPath)
  }
}
